import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { trackingCaseActions } from '../../../application/actions/trackingCase';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// GETALL
export function* getAllFetch(e) {
    yield put(trackingCaseActions.conexionGetAll({connection:true}));
    try {
        const  params  = e.payload;
        const url = `trackingcase/${params.id}`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(trackingCaseActions.getAll({data}));
    } catch (err) {
        yield put(trackingCaseActions.errorGetAll({error:true, message:err.message}));
    } finally {
        yield put(trackingCaseActions.conexionGetAll({connection:false}));
    }
}

export function* watchFetchSesion() {
    yield takeLatest(trackingCaseActionsActionsSaga.getAll.type,  getAllFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchSesion);
}


const getAll = createAction('trackingCaseActions/getAll');

export const trackingCaseActionsActionsSaga = {
    getAll,
};
